<div class="card">
  <div class="card-body">
    <location-add (onComplete)="save()"></location-add>
  </div>
</div>
